"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.misc = exports.fontSize = exports.padding = exports.breakpoints = exports.colors = void 0;
// Use this if using semi-transparent colors/backgrounds
// const getRGBA = (hex: string, alpha = 1): string =>
//     `rgba(${parseInt(hex.substring(1, 3), 16)},${parseInt(hex.substring(3, 5), 16)},${parseInt(
//         hex.substring(5, 7),
//         16,
//     )},${alpha})`;
// --- Colors -- #TODO: this needs to change, to be dynamic
exports.colors = {
    // Brand
    brandPrimary: '#feee00',
    brandSecondary: '#2DAF32',
    // Background
    bgPrimary: '#fff',
    bgSecondary: '#404553',
    bgSupport: '#fcfbf4',
    bgTertiary: '#f7f7fa',
    bgSupportAlt: '#F7F9FE',
    bgSupportLight: '#F1F4FD',
    // Body
    body: '#404553',
    bodyMid: '#7E859B',
    bodyLight: '#e2e5f1',
    bodyLightest: '#f7f7fa',
    bodyAlt: '#ffffff',
    // Border
    border: '#e4f7db',
    borderLight: '#ebecf0',
    borderDark: '#e2e5f1',
    borderBlue: '#008FBE',
    borderLightShadow: '#008FBE',
    // General
    generalWarning: '#ce0f0f',
    generalWarningLight: '#fb0000',
    generalPositive: '#38ae04',
    generalPositiveLight: '#e4f7db',
    generalRating: '#f5a523',
    generalSale: '#f6583d',
    generalFreebie: '#00B06A',
    gereralIconBG: '#fcfbf4',
    generalDeal: '#6236FF',
    generalAttachment: '#6236FF',
    generalBadge: '',
    generalLabel: '',
    // Status
    statusOrdered: '#6236FF',
    statusProcessing: '#6236FF',
    statusShipped: '#6236FF',
};
// --- Breakpoints
var xsMin = 480;
var smMin = 768;
var mdMin = 992;
var lgMin = 1200;
var xlMin = 1366;
var bp = {
    xsMin: xsMin,
    smMin: smMin,
    mdMin: mdMin,
    lgMin: lgMin,
    xlMin: xlMin,
    xsMax: xsMin - 1,
    smMax: smMin - 1,
    mdMax: mdMin - 1,
    lgMax: lgMin - 1,
};
exports.breakpoints = {
    minMobile: "only screen and (min-width: " + bp.xsMin + "px)",
    minTablet: "only screen and (min-width: " + bp.smMin + "px)",
    minDesktop: "only screen and (min-width: " + bp.mdMin + "px)",
    minDesktopLG: "only screen and (min-width: " + bp.lgMin + "px)",
    minDesktopXLG: "only screen and (min-width: " + bp.xlMin + "px)",
    maxMobile: "only screen and (max-width: " + bp.xsMax + "px)",
    maxTablet: "only screen and (max-width: " + bp.smMax + "px)",
    maxDesktop: "only screen and (max-width: " + bp.mdMax + "px)",
    maxDesktopLG: "only screen and (max-width: " + bp.lgMax + "px)",
};
// --- Spacing
exports.padding = {
    xsWrapperPadding: '10px',
    smWrapperPadding: '12px',
    mdWrapperPadding: '15px',
    lgWrapperPadding: '25px',
};
// --- Fonts
exports.fontSize = {
    smBase: '12px',
    mdBase: '13px',
};
// --- Misc
exports.misc = {
    minWidth: '768px',
    maxWidth: '1440px',
    productImageRatio: '136.375%',
    siteHeaderHeightDesktop: '65px',
    siteHeaderHeightMobile: '54px',
    supportBarHeight: '38px',
    mobileSearchHeight: '37px',
};
//# sourceMappingURL=theme.js.map